/**
 * Product
 * Product data model
 */
export class Product {
    constructor(data = {}) {
        this.productId = data.productId || '';
        this.name = data.name || '';
        this.description = data.description || '';
        this.features = data.features || [];
        this.technicalSpecs = data.technicalSpecs || {};
        this.offer = data.offer || {};
        this.targetAudience = data.targetAudience || '';
        this.useCases = data.useCases || [];
        this.docsPath = data.docsPath || null;
        this.source = data.source || 'manual-entry';
        this.extractedAt = data.extractedAt || new Date().toISOString();
        this.extractorVersion = data.extractorVersion || '1.0';
    }

    validate() {
        const errors = [];

        if (!this.productId) {
            errors.push('productId is required');
        }

        if (!this.name) {
            errors.push('name is required');
        }

        return {
            isValid: errors.length === 0,
            errors
        };
    }

    toJSON() {
        return {
            productId: this.productId,
            name: this.name,
            description: this.description,
            features: this.features,
            technicalSpecs: this.technicalSpecs,
            offer: this.offer,
            targetAudience: this.targetAudience,
            useCases: this.useCases,
            docsPath: this.docsPath,
            source: this.source,
            extractedAt: this.extractedAt,
            extractorVersion: this.extractorVersion
        };
    }

    static fromJSON(data) {
        return new Product(data);
    }
}
